import type { DsType } from "../../store/api/dataSourcesApi";

export const DS_TYPE_LABELS: Record<DsType, string> = {
  search_index: "Search Index",
  blob_storage: "Blob Storage",
  unstructured_store: "Unstructured Data Store",
  byo: "Bring Your Own",
};

export const DS_TYPE_DESCRIPTIONS: Record<DsType, string> = {
  search_index: "Full-text search with faceting and ranking",
  blob_storage: "Store and retrieve files and binary objects",
  unstructured_store: "Flexible key-value and document storage",
  byo: "Connect an existing external data source you already manage",
};

export const DS_TYPE_ICONS: Record<DsType, string> = {
  search_index: "\u{1F50D}",
  blob_storage: "\u{1F4E6}",
  unstructured_store: "\u{1F5C2}\uFE0F",
  byo: "\u{1F517}",
};

export const DS_TYPE_BADGE_VARIANT: Record<DsType, string> = {
  search_index: "info",
  blob_storage: "success",
  unstructured_store: "warning",
  byo: "neutral",
};

export const BYO_PROVIDER_LABELS: Record<string, string> = {
  algolia: "Algolia",
  s3: "Amazon S3",
};

export const DEFAULT_SCHEMA_JSON = JSON.stringify(
  {
    fields: [
      { name: "title", type: "string" },
      { name: "description", type: "string" },
      { name: "category", type: "string" },
      { name: "price", type: "number" },
      { name: "in_stock", type: "boolean" },
    ],
  },
  null,
  2,
);

export function inferSchemaFromSample(data: unknown): {
  fields: { name: string; type: string }[];
} {
  const items = Array.isArray(data) ? data : [data];
  if (items.length === 0 || typeof items[0] !== "object" || items[0] === null) {
    return { fields: [] };
  }
  const sample = items[0] as Record<string, unknown>;
  const fields = Object.keys(sample).map((key) => ({
    name: key,
    type:
      typeof sample[key] === "object" && sample[key] !== null
        ? Array.isArray(sample[key])
          ? "array"
          : "object"
        : typeof sample[key],
  }));
  return { fields };
}
